import React from "react";
import { Link } from "react-router-dom";
import homeActive from "../../assets/image/home_active.svg"
import homeDefault from "../../assets/image/home_default.svg"
import searchActive from "../../assets/image/search_active.svg"
import searchDefault from "../../assets/image/search_default.svg"
import menuActive from "../../assets/image/menu_active.svg"
import menuDefault from "../../assets/image/menu_default.svg"
import adActive from "../../assets/image/playbox_active.svg"
import adDefault from "../../assets/image/playbox_default.svg"
import userActive from "../../assets/image/user_active.svg"
import userDefault from "../../assets/image/user_default.svg"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";

function AppBar() {

  const paths = location.pathname.split("/");
  const pathName = paths[paths.length - 1];
  let nowTab = "home";
  /*switch (pathName) {
    case "search":
      nowTab = "search";
      break;
    case "menu":
      nowTab = "menu";
      break;
    case "ad":
      nowTab = "ad";
      break;
    case "mypage":
      nowTab = "mypage";
      break;
  }*/

  if (paths.includes("search")) {
    nowTab = "search"
  } else if (paths.includes("menu") || paths.includes("magazine") || paths.includes("lit") || paths.includes("stat") || paths.includes("job")) {
    nowTab = "menu"
  } else if (paths.includes("ad") || paths.includes("forum") ) {
    nowTab = "ad"
  } else if (paths.includes("mypage")) {
    nowTab = "mypage"
  } else if (paths.includes("")) {
    nowTab = "home"
  }

  return (
    <nav id="appBar">
      <a href={convertPath("")} className={`${nowTab === 'home' ? "tab clicked" : "tab"}`}>
        {nowTab === 'home' ?
          <LazyLoadImage src={homeActive} alt=""/>
          :
          <LazyLoadImage src={homeDefault} alt=""/>
        }
      </a>
      <a href={convertPath('/search')} className={`${nowTab === 'search' ? "tab clicked" : "tab"}`}>
        {nowTab === 'search' ?
          <LazyLoadImage src={searchActive} alt=""/>
          :
          <LazyLoadImage src={searchDefault} alt=""/>
        }
      </a>
      <a href={convertPath('/menu')} className={`${nowTab === 'menu' ? "tab clicked" : "tab"}`}>
        {nowTab === 'menu' ?
          <LazyLoadImage src={menuActive} alt=""/>
          :
          <LazyLoadImage src={menuDefault} alt=""/>
        }
      </a>
      <a href={convertPath('/ad/tv')} className={`${nowTab === 'ad' ? "tab clicked" : "tab"}`}>
        {nowTab === 'ad' ?
          <LazyLoadImage src={adActive} alt=""/>
          :
          <LazyLoadImage src={adDefault} alt=""/>
        }
      </a>
      <a href={convertPath('/mypage')} className={`${nowTab === 'mypage' ? "tab clicked" : "tab"}`}>
        {nowTab === 'mypage' ?
          <LazyLoadImage src={userActive} alt=""/>
          :
          <LazyLoadImage src={userDefault} alt=""/>
        }
      </a>
    </nav>
  );
}

export default AppBar;


//
